// src/services/courseService.ts

export const fetchAnnouncements = async (courseId: string, course_url: string, app_id: string, isRefresh?: boolean) => {
    let refresh_document_cache = !!isRefresh;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/canvas/get-announcements`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ course_id: courseId, course_url,refresh_document_cache,app_id }),
    });
    const result = await response.json();

    // Ensure assignmentsData is always an array
    if (response.ok && Array.isArray(result.data)) {
        return result.data;
    } else {
        return []; // Return an empty array if data is not valid
    }
};
export const fetchAssignments = async (courseId: string, course_url: string, app_id: string, isRefresh?: boolean) => {
    let refresh_document_cache = !!isRefresh;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/canvas/get-assignments`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ course_id: courseId, course_url, refresh_document_cache,app_id }),
    });
    const result = await response.json();

    // Ensure assignmentsData is always an array
    if (response.ok && Array.isArray(result.data)) {
        return result.data;
    } else {
        return []; // Return an empty array if data is not valid
    }
};

export const fetchDiscussions = async (courseId: string, course_url: string, app_id: string, isRefresh?: boolean) => {
    let refresh_document_cache = !!isRefresh;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/canvas/get-discussions`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ course_id: courseId, course_url , refresh_document_cache,app_id}),
       
    });
    const result = await response.json();

    // Ensure assignmentsData is always an array
    if (response.ok && Array.isArray(result.data)) {
        return result.data;
    } else {
        return []; // Return an empty array if data is not valid
    }
};
export const fetchFiles = async (courseId: string, course_url: string, app_id: string, isRefresh?: boolean) => {
    let refresh_document_cache = !!isRefresh;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/canvas/get-files`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ course_id: courseId, course_url, refresh_document_cache,app_id }),
        
    });
    const result = await response.json();

    // Ensure assignmentsData is always an array
    if (response.ok && Array.isArray(result.data)) {
        return result.data;
    } else {
        return []; // Return an empty array if data is not valid
    }
};
export const fetchModules = async (courseId: string, course_url: string , app_id: string, isRefresh?: boolean) => {
    let refresh_document_cache = !!isRefresh;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/canvas/get-modules`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ course_id: courseId,course_url, refresh_document_cache, app_id }),
        
    });
    const result = await response.json();

    // Ensure assignmentsData is always an array
    if (response.ok && Array.isArray(result.data)) {
        return result.data;
    } else {
        return []; // Return an empty array if data is not valid
    }
};
export const fetchPages = async (courseId: string, course_url: string, app_id: string, isRefresh?: boolean) => {
    let refresh_document_cache = !!isRefresh;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/canvas/get-pages`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ course_id: courseId,course_url, refresh_document_cache, app_id }),
        
    });
    const result = await response.json();

    // Ensure assignmentsData is always an array
    if (response.ok && Array.isArray(result.data)) {
        return result.data;
    } else {
        return []; // Return an empty array if data is not valid
    }
};
export const fetchEnrollments = async (courseId: string, course_url: string, app_id: string, isRefresh?: boolean) => {
    let refresh_document_cache = !!isRefresh;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/canvas/get-enrollments`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ course_id: courseId ,course_url,refresh_document_cache,app_id}),
    });
    const result = await response.json();

    // Ensure assignmentsData is always an array
    if (response.ok && Array.isArray(result.data)) {
        return result.data;
    } else {
        return []; // Return an empty array if data is not valid
    }
};
export const fetchQuizzes = async (courseId: string, course_url: string, app_id: string, isRefresh?: boolean) => {
    let refresh_document_cache = !!isRefresh;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/canvas/get-quizzes`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ course_id: courseId, course_url, refresh_document_cache,app_id }),
    });
    const result = await response.json();

    // Ensure assignmentsData is always an array
    if (response.ok && Array.isArray(result.data)) {
        return result.data;
    } else {
        return []; // Return an empty array if data is not valid
    }
};
  
export const fetchSyllabus = async (courseId: string, course_url: string, app_id: string, isRefresh?: boolean) => {
    let refresh_document_cache = !!isRefresh;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/canvas/get-syllabus`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ course_id: courseId,course_url, refresh_document_cache,app_id }),

    });
    const result = await response.json();

    // Ensure assignmentsData is always an array
    if (response.ok && Array.isArray(result.data.syllabus)) {
        return result.data.syllabus;
    } else {
        return []; // Return an empty array if data is not valid
    }
};

interface CourseIdentifier {
    course_id: string;
    course_url?: string;
  }
export const getUsers = async (courseIdentifiers: CourseIdentifier[]) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/canvas/get-users`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ courses: courseIdentifiers }),

    });
    const result = await response.json();

    // Ensure assignmentsData is always an array
    if (response.ok && Array.isArray(result.data)) {
        return result.data;
    } else {
        return []; // Return an empty array if data is not valid
    }
};